import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const loginSchemaValidation = Yup.object().shape({
  email: Yup.string().email('E-mail inválido').required('E-mail obrigatório'),
  password: Yup.string().required('Senha obrigatória'),
});

export const loginValidationResolver = yupResolver(loginSchemaValidation);
